import Swal from "sweetalert2";
import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Button, Table, Input, Space, Select, Empty } from "antd";
import { CopyTextToClipboard } from "../../helpers/copy";
import { DetailModelCustomer } from "../../components/Model/index-model";
import {
  AddCustomerModel,
  EditCustomerModel,
} from "../../components/Model/add-model";
import config from "../../config/app.config";
import { withTranslation } from "react-i18next";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import {
  formatAccnumID,
  formatName,
  formatPromptPayNumber,
  hasPermission,
  openNotification,
  scrollToAntSpinContainer,
  sendApiTelegram_activity,
  sendApiTelegram_call_api_error,
  showToast,
} from "../../utils";
import AppContext from "../../components/AppContext";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { t } from "i18next";
import { ColumnsCustomer } from "../../components/Columns/columns-customer";
import {
  CheckOutlined,
  ClockCircleOutlined,
  FilterOutlined,
  LockOutlined,
  QuestionCircleOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { VerifySlipModel } from "../../components/Model/verify-slip-model";
import Apiauth from "../../api/Apiauth";
import debounce from "lodash.debounce";
import { FooterCustomer } from "../../components/Footer";

const tagsBageStatus = (status) => {
  switch (status) {
    case "SUCCESS":
    case "success":
      return "rgb(82, 196, 26)";
    case "PENDING":
    case "PROCESSING":
      return "#faad14";
    case "FAILED":
    case "REJECTED":
    case "not_found":
      return "rgb(245, 34, 45)";
    default:
      return "default";
  }
};
const tagsBageIcon = (status) => {
  switch (status) {
    case "SUCCESS":
    case "success":
      return <CheckOutlined />;
    case "PENDING":
    case "PROCESSING":
      return <ClockCircleOutlined />;
    case "not_found":
    case "REJECTED":
    case "FAILED":
      return <LockOutlined />;
    default:
      return <QuestionCircleOutlined />;
  }
};
class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      showDetailModel: false,
      dropdownPlacement: "bottomRight",
      showAddModel: false,
      showEditModel: false,
      selectedRecord: "",
      isData: null,
      currentLang: props.i18n.language,
      isLoad: false,
      showVerifyModel: false,
      typeSearch: "telephoneNumber",
      search: "",
    };
    this.onSearch = this.onSearch.bind(this);
    this.onFetchData = this.onFetchData.bind(this);

    // สร้าง debounced function
    this.debouncedSearch = debounce(this.onSearch, 200);
    this.debouncedFetch = debounce(this.onFetchData, 100);
    this.tableRef = React.createRef();
  }
  // --- Lifecycle Methods ---
  componentDidMount() {
    const { activeKey1, setLoadingCustomer } = this.context;
    if (activeKey1 === "bank-bank-customer") {
      setLoadingCustomer(true);
      this.debouncedSearch();
      window.scrollTo(0, 0);
    }

    window.addEventListener("scroll", this.handleScroll);
    this.props.i18n.on("languageChanged", this.handleLanguageChange);
  }
  componentDidUpdate(prevProps, prevState) {
    window.removeEventListener("scroll", this.handleScroll);
  }
  setLoading = (_loading) => {
    this.setState({
      isLoad: _loading,
    });
  };
  handleScroll = () => {
    const tableElement = this.tableRef.current;
    if (tableElement) {
      const isAtBottom =
        tableElement.getBoundingClientRect().bottom <= window.innerHeight;
      this.setState({
        dropdownPlacement: isAtBottom ? "topLeft" : "bottomRight",
      });
    }
  };
  componentWillUnmount() {
    this.props.i18n.off("languageChanged", this.handleLanguageChange);
    this.debouncedSearch.cancel();
    this.debouncedFetch.cancel();
  }

  handleLanguageChange = (lng) => {
    this.setState({ currentLang: lng });
  };
  handleShowDetail = (key) => {
    if (!key) {
      showToast("error", t("Invalid data."));
      return;
    }
    if (key === "Not allowed") {
      return alert(
        `!You are not authorized to view or take any action on any other store.`,
      );
    }
    this.setState({ showDetailModel: true, selectedRecord: key });
  };

  handleShowAddModel = () => {
    this.setState({ showAddModel: true });
  };
  handleShowVerifyModel = (record) => {
    if (!record) {
      openNotification("error", "เกิดข้อผิดพลาด", "ไม่พบข้อมูล Customer");
      return;
    } else if (record?.status !== "SUCCESS") {
      openNotification(
        "error",
        "เกิดข้อผิดพลาด",
        `Customer Status:'${record?.status}' ไม่พร้อมใช้งาน`,
      );
      return;
    }
    this.setState({ showVerifyModel: true, isData: record });
  };

  handleShowEditModel = (key) => {
    if (!key) {
      showToast("error", t("Invalid data."));
      return;
    }
    if (key === "Not allowed") {
      return alert(
        `!You are not authorized to view or take any action on any other store.`,
      );
    }
    this.setState({ showEditModel: true, selectedRecord: key });
  };

  handleCloseModals = () => {
    this.setState({
      showDetailModel: false,
      showAddModel: false,
      showEditModel: false,
      showVerifyModel: false,
      isData: "",
      selectedRecord: "",
    });
  };

  handleConfirm_account = (key) => {
    if (!key) {
      showToast("error", t("Invalid data."));
      return;
    }
    if (key === "Not allowed") {
      return alert(
        `!You are not authorized to view or take any action on any other store.`,
      );
    }

    if (!key?.customer_uuid) {
      showToast("error", "ไม่พบ UUID หรือ token_auth ไม่ถูกต้อง");
      return;
    }

    const { isMerchantData, resProfileAdmin } = this.context;
    const adminName = resProfileAdmin?.username || "Unknown Admin";

    //
    let isName = `${key?.bank_code}, ${key?.account_no}, ${key?.name}`;
    const details = `${adminName} (${resProfileAdmin?.admin_type}) Verify Account Customer : ${isName}`;
    Swal.fire({
      title: t("Are you sure?"),
      text: `${t("VerifyAccount", { name: isName })}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setLoading(true);
        try {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append(
            "Authorization",
            `Bearer ${isMerchantData?.token_auth || ""}`,
          );

          const raw = JSON.stringify({
            customer_uuid: key?.customer_uuid,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(
            `${config.apiURL}/api/v2/merchans/create_customers`,
            requestOptions,
          )
            .then((response) => response.json())
            .then((result) => {
              sendApiTelegram_activity(
                result,
                "Verify Account Customer",
                details,
                resProfileAdmin,
              );
              if (result.success) {
                showToast("success", result.message);
                this.setLoading(false);
                this.context.getAllDataCustomer();
              } else {
                showToast("error", result.message);
                this.setLoading(false);
              }
            })
            .catch((error) => {
              sendApiTelegram_call_api_error(
                error,
                "[FAILED] Verify Account Customer",
              );
              showToast("error", "Error fetching data.");
              console.error(error);
              this.setLoading(false);
            });
        } catch (error) {
          console.error(error);
          this.setLoading(false);
          sendApiTelegram_call_api_error(error, "Verify Account Customer");
        }
      }
    });
  };
  handleDelete = async (record) => {
    if (!record) {
      alert(t("Invalid data."));
      return;
    }
    let { id, merchantId, name, account_no, bank_code } = record;

    if (record === "Not allowed") {
      return alert(
        `!You are not authorized to view or take any action on any other store.`,
      );
    }
    if (!id) {
      alert(t("Invalid data."));
      return;
    }

    let postData = {
      merchantId: merchantId,
      id: id,
    };
    const { getAllDataCustomer, isMerchantData, resProfileAdmin } =
      this.context;
    const shopName = isMerchantData?.name || "ไม่ระบุชื่อร้าน";
    const adminName = resProfileAdmin?.username || "Unknown Admin";
    let isName = `${bank_code}, ${account_no}, ${name}`;

    const details = `ร้าน ${shopName} : ${adminName} (${resProfileAdmin?.admin_type}) Delete Customer : ${isName}`;
    Swal.fire({
      title: this.props.t("Are you sure?"),
      text: this.props.t(`Do you want to delete this Customer ID : ${id}?`),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.props.t("Confirm"),
      cancelButtonText: this.props.t("cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.setLoading(true);
        try {
          const response = await Apiauth.getDeleteCustomer(postData);
          sendApiTelegram_activity(
            response,
            "Delete Customer",
            details,
            resProfileAdmin,
          );
          if (response.status === 200) {
            showToast(
              "success",
              this.props.t(response.data.message || "successful"),
            );
            if (typeof getAllDataCustomer === "function") {
              getAllDataCustomer();
            }
          } else {
            showToast(
              "error",
              response.data.message ||
              this.props.t(
                response.data.message || "failed_to_delete_customer",
              ),
            );
          }
        } catch (error) {
          sendApiTelegram_call_api_error(error, "Delete Customer");
          console.error("Error deleting customer bank account:", error);
          showToast("error", this.props.t("error_deleting_customer"));
        } finally {
          this.setLoading(false);
        }
      }
    });
  };

  onFetchData = (event) => {
    const { getAllDataCustomer } = this.context;
    if (getAllDataCustomer) {
      getAllDataCustomer(event);
    }
  };

  handleTableChange = (pagination, filters, sorter) => {
    const { setLoadingCustomer } = this.context;
    setLoadingCustomer(true);
    const newTableParams = {
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
      filters: {
        ...filters,
      },
      sortField: Array.isArray(sorter) ? sorter[0]?.field : sorter.field,
      sortOrder: Array.isArray(sorter) ? sorter[0]?.order : sorter.order,
    };
    this.debouncedFetch(newTableParams);
    scrollToAntSpinContainer();
  };
  onSearch = () => {
    const { search, typeSearch } = this.state;

    const newTableParams = {
      pagination: {
        current: 1,
        pageSize: this.context.customerTableParams.pagination.pageSize,
      },
      filters: {
        search: search,
        typeSearch: typeSearch,
      },
    };

    this.debouncedFetch(newTableParams);
  };
  onChangeTypeSearch = (key, value) => {
    const { setLoadingCustomer } = this.context;
    setLoadingCustomer(true);
    this.setState({ [key]: value }, () => this.debouncedSearch());
  };
  onChangeSearch = (key, value) => {
    const { setLoadingCustomer } = this.context;
    setLoadingCustomer(true);
    this.setState({ [key]: value }, () => this.debouncedSearch());
  };
  onTab1Change = (key) => {
    this.setState({ activeTabKey1: key });
  };
  // --- Render Method ---
  render() {
    const { t } = this.props;
    const {
      countCustomer,
      customerTableParams,
      customerData,
      isCustomerLoading,
      getAllDataCustomer,
      handleCheckError,
      tokenMerchant,
      nameMerchang,
      resAllDataMerchang,
      allBankAccountData,
      isMerchantData,
      resProfileAdmin,
    } = this.context;

    const {
      activeTabKey1,
      showDetailModel,
      selectedRecord,
      showAddModel,
      showEditModel,
      dropdownPlacement,
      showVerifyModel,
      isData,
    } = this.state;

    const {
      handleConfirm_account,
      handleShowDetail,
      handleShowEditModel,
      handleDelete,
      handleShowVerifyModel,
    } = this;
    const columns = ColumnsCustomer(
      nameMerchang,
      CopyTextToClipboard,
      formatPromptPayNumber,
      formatAccnumID,
      tagsBageStatus,
      t,
      FormatTimeAgo,
      handleConfirm_account,
      handleShowDetail,
      handleShowEditModel,
      handleDelete,
      dropdownPlacement,
      formatName,
      customerTableParams,
      handleShowVerifyModel,
      tagsBageIcon,
      resProfileAdmin
    );
    const tabList = [
      {
        key: "tab1",
        tab: `${t("customer_list_all")} ( ${Intl.NumberFormat().format(countCustomer)} )`,
      },
    ];
    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.customer_uuid || record.id}
              onChange={this.handleTableChange}
              dataSource={customerData || []}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              loading={isCustomerLoading}
              pagination={{
                ...customerTableParams.pagination,
                showSizeChanger: true,
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = customerTableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / customerTableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };
    const options = [
      {
        value: "name",
        label: t("customer name"),
      },
      {
        value: "account_no",
        label: t("account number"),
      },
      {
        value: "telephoneNumber",
        label: t("telephoneNumber"),
      },
      {
        value: "customer_uuid",
        label: t("customer_uuid"),
      },
    ];

    const userPermissions = Array.isArray(resProfileAdmin?.permissions)
      ? resProfileAdmin.permissions
      : [];

    // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
    const accessible = hasPermission(userPermissions, "add_customer");

    return (
      <>
        {/* Modals */}
        <DetailModelCustomer
          handleClose={this.handleCloseModals}
          isData={selectedRecord}
          showToast={showToast}
          show={showDetailModel}
          activeTabKey1={activeTabKey1}
          allBankAccountData={allBankAccountData}
          resAllDataMerchang={resAllDataMerchang}
          nameMerchang={nameMerchang}
          t={t}
        />
        <AddCustomerModel
          handleClose={this.handleCloseModals}
          show={showAddModel}
          t={t}
          fetchData={getAllDataCustomer}
          isMerchantData={isMerchantData}
          resProfileAdmin={resProfileAdmin}
        />
        <EditCustomerModel
          handleClose={this.handleCloseModals}
          isData={selectedRecord}
          show={showEditModel}
          fetchData={getAllDataCustomer}
          handleCheckError={handleCheckError}
          tokenMerchant={tokenMerchant}
          isMerchantData={isMerchantData}
          resProfileAdmin={resProfileAdmin}
          t={t}
        />
        <VerifySlipModel
          handleClose={this.handleCloseModals}
          show={showVerifyModel}
          isData={isData}
          nameMerchang={nameMerchang}
          t={t}
          fetchData={getAllDataCustomer}
          resAllDataMerchang={resAllDataMerchang}
        />

        {/* Page Content */}
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("Customer's")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                    navigate: window.location.pathname,
                  },
                ]}
              />
              <br className="sm-hiden" />
              <Card
                title={accessible ?
                  <Button
                    icon={<UserAddOutlined />}
                    onClick={() => {
                      if (accessible) {
                        this.handleShowAddModel();
                      } else {
                        alert(
                          t(`You do not have the right to add customers.`),
                        );
                      }
                    }}
                  >
                    {t("add")}
                  </Button>
                  : null}
                extra={
                  <Space.Compact className="sm-200">
                    <Select
                      suffixIcon={<FilterOutlined />}
                      onChange={(value) =>
                        this.onChangeTypeSearch("typeSearch", value)
                      }
                      defaultValue={"telephoneNumber"}
                      autoFocus={false}
                      options={options}
                    />
                    <Input
                      autoFocus={false}
                      placeholder={t(`Search`)}
                      style={{ padding: "4px 11px" }}
                      onChange={(e) =>
                        this.onChangeSearch("search", e.target.value)
                      }
                    />
                  </Space.Compact>
                }
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={this.onTab1Change}
              >
                {contentList[activeTabKey1]}

                <FooterCustomer t={t} />
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, null)(withTranslation()(Index));
